import * as Yup from "yup";

export const signInSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email must be a valid email")
    .required("Email is required"),

  password: Yup.string()
    .required("Password is required")
    .min(6, "Password is too short - should be 6 characters minimum"),
});

export const signUpSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(2, "Name is too short - should be 2 characters minimum"),
  email: Yup.string()
    .email("Email must be a valid email")
    .required("Email is required"),

  password: Yup.string()
    .required("Password is required")
    .min(8, "Password is too short - should be 6 characters minimum")
    .max(25, "Password is too long - should be 6 characters maximum")
    .matches(
      /^[a-z0-9]+$/gi,
      "Password can not contain white space and special characters"
    ),
  confirmPassword: Yup.string()
    .required("Confirm your password")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
});

export const changeDetailsSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(2, "Name is too short - should be 2 characters minimum"),
  currentPassword: Yup.string()
    .required("Password is required")
    .min(8, "Password is too short - should be 6 characters minimum")
    .max(25, "Password is too long - should be 6 characters maximum")
    .matches(
      /^[a-z0-9]+$/gi,
      "Password can not contain white space and special characters"
    ),
  currentPasswordConfirmed: Yup.bool()
    .required()
    .oneOf([true], "Please enter a correct password"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password is too short - should be 6 characters minimum")
    .max(25, "Password is too long - should be 6 characters maximum")
    .matches(
      /^[a-z0-9]+$/gi,
      "Password can not contain white space and special characters"
    ),
  confirmPassword: Yup.string()
    .required("Confirm your password")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
});
